/**
 * 點通知之後的跳轉：「已讀」要先送到伺服器，才能整頁離開。
 *
 * 點通知會做兩件事：送出「已讀」、跳去通知指的頁面。社群與 AI 站的通知是
 * 絕對網址，跳過去是整頁換掉 —— 瀏覽器換頁時會中斷還沒送完的請求，伺服器
 * 沒收到「已讀」，10 秒後輪詢未讀數又從伺服器拿回原本的數字，紅點也回來。
 * 網路快的時候請求趕得上（所以有人測起來正常），手機或網路慢就常常趕不上。
 *
 * 站內路由（router.push）不換頁，請求不會被中斷，不用等。
 */
import { isCustomDomain } from "@/utils/custom-domain";

/** 這次跳轉會不會整頁離開目前頁面 */
export function leavesPage(route) {
  if (!route) return false;
  if (/^https?:\/\//i.test(route)) return true;
  // 自訂網域上的會員區是整頁跳回平台網域（見 custom-domain-auth 的 navigateMemberArea）
  return isCustomDomain();
}

/**
 * 通知連結的實際網址。三站共用同一份通知：社群（sms）與 AI（aichat）的通知平常是絕對網址，
 * 但後台手動公告選了社群／AI 卻填相對路徑、或 AI 站沒設定網址時，在平台會被當成平台的頁面，
 * 掉進找不到頁面 → /error。相對路徑一律接上來源站的網域。
 */
export function resolveNotificationRoute(route, sourceSite) {
  if (!route || /^https?:\/\//i.test(route)) return route;
  const site = String(sourceSite || "").toLowerCase();
  const base =
    site === "sms"
      ? process.env.VUE_APP_MAIN_SMS_BASE_URL
      : site === "aichat"
      ? process.env.VUE_APP_MAIN_AICHAT_BASE_URL
      : "";
  if (!base) return route;
  return base.replace(/\/+$/, "") + (route.startsWith("/") ? route : `/${route}`);
}

/** 等 promise 完成，但最多等 ms 毫秒 —— 請求卡住時不能讓使用者一直跳不過去 */
export function waitAtMost(promise, ms = 1500) {
  return Promise.race([Promise.resolve(promise).catch(() => {}), new Promise((resolve) => setTimeout(resolve, ms))]);
}
